export const BROWSER_IMAGE_FORMAT_LABEL = "JPG, PNG, or WebP";
export const BROWSER_IMAGE_ACCEPT =
  "image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp";

const SUPPORTED_BROWSER_IMAGE_MIME_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/webp",
]);
const GENERIC_BINARY_MIME_TYPE = "application/octet-stream";
const SUPPORTED_BROWSER_IMAGE_EXTENSIONS = /\.(?:jpe?g|png|webp)$/i;

export type BrowserImagePreparationErrorCode =
  | "unsupported_format"
  | "input_too_large"
  | "unreadable_image"
  | "output_too_large";

export class BrowserImagePreparationError extends Error {
  constructor(public readonly code: BrowserImagePreparationErrorCode) {
    super(code);
    this.name = "BrowserImagePreparationError";
  }
}

/**
 * Formats that can be decoded and normalized by the browser before upload.
 * Some mobile file pickers omit the MIME type or report a generic binary MIME;
 * in those cases the extension is only a candidate signal. Successful canvas
 * decoding is still required before the file can be uploaded.
 */
export function isSupportedBrowserImage(
  file: Pick<File, "name" | "type">
): boolean {
  const normalizedType = file.type.toLowerCase();
  return (
    SUPPORTED_BROWSER_IMAGE_MIME_TYPES.has(normalizedType) ||
    ((normalizedType === "" || normalizedType === GENERIC_BINARY_MIME_TYPE) &&
      SUPPORTED_BROWSER_IMAGE_EXTENSIONS.test(file.name))
  );
}
